module.exports = __webpack_public_path__ + "img/logo-the-fives-3.5c379953.svg";